import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { NavigationPanel } from './navigation-panel.model';
import { TabHandlerService } from '../../services/tab-handler.service';
import { RoleAuthorizationService } from 'src/app/services/role-authorization.service';
import { AzureLoginService } from 'src/app/services/azure-login.service';

@Component({
  standalone: false,
  selector: 'navigation-panel',
  templateUrl: 'navigation-panel.template.html',
  providers: [TabHandlerService],
})
export class NavigationPanelComponent implements OnInit, OnChanges, OnDestroy {
  @Input() navigationPanel: NavigationPanel[];
  @Input() reload: boolean;
  selectedTab: any;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private roleAuth: RoleAuthorizationService,
    private azureService: AzureLoginService,
    private tabHandlerService: TabHandlerService,
  ) {}

  ngOnInit() {
    this.applyNavigationAuthorization();
    this.azureService.rolePermissionsUpdated$
      .pipe(startWith(undefined), takeUntil(this.destroy$))
      .subscribe(() => this.applyNavigationAuthorization());
    this.tabHandlerService.selectedTab.subscribe((tab) => {
      if (tab) {
        this.selectedTab = tab;
      }
    });
  }

  ngOnChanges() {
    this.applyNavigationAuthorization();
    this.tabHandlerService.selectedTab.next(this.navigationPanel[0]?.tabKey);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyNavigationAuthorization(): void {
    if (!this.navigationPanel?.length) {
      return;
    }
    this.navigationPanel = this.roleAuth.validateSideMenu(this.navigationPanel);
  }
}
